export { EloMinusCircleIcon } from './minus-circle-icon'
